import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import { toJalali } from "lib/helpers";
import ManageComment from "./ManageComment";

export default function Comments() {
  const path = {
    baseRoute: "/panel/comments",
    aliasName: "نظرات",
    type: "Comment",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    customRequest,
    update,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();

  const [showManage, setShowManage] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(false);

  useEffect(() => {
    dispatch(getList(path));

    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <ManageComment
        load={load}
        item={item}
        show={showManage}
        title="نمایش نظر"
        msg=""
        delete={() => {
          dispatch(
            remove(path, list, item.id, () => {
              dispatch(getList(path));
              setShowManage(false);
            })
          );
        }}
        accept={() => {
          dispatch(
            customRequest(
              "patch",
              `${path.baseRoute}/${item.id}`,
              { status: "ACCEPTED" },
              () => {
                dispatch(getList(path));
                setShowManage(false);
              }
            )
          );
        }}
        close={() => {
          setShowManage(false);
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">نظرات</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {load && (
              <div className="hidden md:block mx-auto text-gray-600 text-white">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600 text-white">
                {from && `نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">کاربر</th>
                  <th className="whitespace-nowrap text-center">نظر</th>
                  <th className="whitespace-nowrap text-center">وضعیت</th>
                  <th className="whitespace-nowrap text-center"> تاریخ ثبت</th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item) => (
                    <tr className="intro-x">
                      <td>
                        <p className="font-medium text-center">
                          {item.creator && item.creator.full_name}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium text-center">{item.body}</p>
                      </td>
                      <td className="text-center">
                        {" "}
                        {item.status == "ACCEPTED"
                          ? "تایید شده"
                          : "در انتظار بررسی"}
                      </td>
                      <td className="text-center">
                        {" "}
                        {toJalali(item.created_at, "HH:mm:ss jYYYY/jM/jD")}
                      </td>
                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          <a
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowManage(true);
                            }}
                          >
                            {" "}
                            <Icons.Eye className="w-4 h-4 ml-1" /> مدیریت{" "}
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
